import "./style.css";

interface Props {
  tabSelected: "ball-data" | "club-data" | "key-data";
  setSelectedTabFunc: any
}

const TabSelectedKeyWrapper = ({ tabSelected, setSelectedTabFunc }: Props): JSX.Element => {
  return (
    <div className="tab-selected-key-wrapper">
      <div className="tabs">
        <div className="tab-item">
          <div className={`tab-text ${tabSelected === "key-data" ? "tab-selected" : "tab-not-selected"}`} onClick={() => setSelectedTabFunc("key-data")}>Key Data</div>
        </div>
        <div className="tab-item">
          <div className={`tab-text ${tabSelected === "club-data" ? "tab-selected" : "tab-not-selected"}`} onClick={() => setSelectedTabFunc("club-data")} >Club Data</div>
        </div>
        <div className="tab-item">
          <div className={`tab-text ${tabSelected === "ball-data" ? "tab-selected" : "tab-not-selected"}`} onClick={() => setSelectedTabFunc("ball-data")}>Ball Data</div>
        </div>
      </div>
      {/* <div className={`active-tab-bar tab-selected-2-${tabSelected}`} /> */}
    </div>
  );
};

export default TabSelectedKeyWrapper;
